import { alpha, styled } from "@mui/material";
import { Pill } from "@volt_developers/components";

interface EnvironmentPillProps {
  environment: "Both" | "Prod" | "Sand";
}

const PILL_WIDTH = 46;

export function EnvironmentPill({ environment }: EnvironmentPillProps) {
  return (
    <StyledPill {...ENVIRONMENT_PILL_COLORS[environment]}>
      {environment}
    </StyledPill>
  );
}

const StyledPill = styled(Pill)({
  width: PILL_WIDTH,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const ENVIRONMENT_PILL_COLORS = {
  Prod: {
    color: "#1b63cf",
    backgroundColor: alpha("#1b63cf", 0.1),
    borderColor: alpha("#1b63cf", 0.1),
  },
  Sand: {
    color: "#e09400",
    backgroundColor: alpha("#ffa800", 0.1),
    borderColor: alpha("#ffa800", 0.1),
  },
  Both: {
    color: "#696f8c",
    backgroundColor: alpha("#696f8c", 0.1),
    borderColor: alpha("#696f8c", 0.1),
  },
};
